'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lc_menu = [
	{
		name: "MISSION",
		link: "https://www.lanl.gov/mission/index.php",
		lc_page_groups: [
		]
	},
	{
		name: "SCIENCE & INNOVATION",
		link: "https://www.lanl.gov/science-innovation/index.php",
		lc_page_groups: [
			{
				name: "Science & Innovation",
				link: "https://www.lanl.gov/science-innovation/index.php",
				lc_pages: [
					{
						name: "Science Highlights",
						link: "https://www.lanl.gov/science-innovation/index.php"
					},
					{
						name: "Science Briefs",
						link: "https://www.lanl.gov/discover/science-briefs/index.php"
					},
					{
						name: "Science Facilities",
						link: "https://www.lanl.gov/science-innovation/science-facilities/index.php"
					},
					{
						name: "Capability Pillars",
						link: "https://www.lanl.gov/science-innovation/pillars/index.php"
					},
					{
						name: "Science Videos",
						link: "https://www.lanl.gov/science-innovation/science-videos1.php"
					},
					{
						name: "Lab Organizations",
						link: "https://www.lanl.gov/org/index.php"
					},
					{
						name: "Research Library",
						link: "https://researchlibrary.lanl.gov/"
					}
				]
			},
			{
				name: "Science Programs",
				link: "https://www.lanl.gov/science-innovation/science-programs/index.php",
				lc_pages: [
					{
						name: "Applied Energy Programs",
						link: "https://www.lanl.gov/science-innovation/science-programs/applied-energy-programs/index.php"
					},
					{
						name: "Civilian Nuclear Energy Programs",
						link: "https://www.lanl.gov/science-innovation/science-programs/civilian-nuclear-programs/index.php"
					},
					{
						name: "Laboratory Directed Research & Development (LDRD)",
						link: "https://www.lanl.gov/science-innovation/science-programs/ldrd/index.php"
					},
					{
						name: "National Security Education Center (NSEC)",
						link: "https://www.lanl.gov/projects//national-security-education-center/index.php"
					},
					{
						name: "Office of Science Programs",
						link: "https://www.lanl.gov/science-innovation/science-programs/office-of-science-programs/index.php"
					}
				]
			}
		]
	},
	{
		name: "COLLABORATION",
		link: "https://www.lanl.gov/collaboration/index.php",
		lc_page_groups: [
			{
				name: "User Facilities",
				link: "https://www.lanl.gov/collaboration/user-facilities/index.php",
				lc_pages: [
					{
						name: "CINT",
						link: "http://cint.lanl.gov/index.php"
					},
					{
						name: "LANSCE",
						link: "http://lansce.lanl.gov/"
					},
					{
						name: "NHMFL",
						link: "https://nationalmaglab.org/user-facilities/pulsed-field-facility"
					},
					{
						name: "Biosurveillance Gateway",
						link: "https://www.lanl.gov/projects//biosurveillance-gateway/index.php"
					},
					{
						name: "Pathogen Databases",
						link: "https://www.lanl.gov/collaboration/pathogen-database/index.php"
					}
				]
			},
			{
				name: "Feynman Center For Innovation",
				link: "https://www.lanl.gov/projects//feynman-center/index.shtml",
				lc_pages: [
					{
						name: "LACED",
						link: "https://www.lanl.gov/projects//explosives-detection/index.php"
					},
					{
						name: "Exascale Computing Project",
						link: "https://www.lanl.gov/projects//exascale-computing-project/index.php"
					},
					{
						name: "FUTURE",
						link: "https://www.lanl.gov/projects//future/index.php"
					}
				]
			},
			{
				name: "National Security Education Center (NSEC)",
				link: "https://www.lanl.gov/projects//national-security-education-center/index.php",
				lc_pages: [
					{
						name: "Center for Nonlinear Studies",
						link: "https://www.lanl.gov/projects//national-security-education-center/center-nonlinear-studies/index.php"
					},
					{
						name: "Engineering Institute",
						link: "https://www.lanl.gov/projects//national-security-education-center/engineering/index.php"
					},
					{
						name: "Information Science & Technology Institute",
						link: "https://www.lanl.gov/projects//national-security-education-center/information-science-technology/index.php"
					},
					{
						name: "Center for Space and Earth Science",
						link: "https://www.lanl.gov/projects//national-security-education-center/space-earth-center/index.php"
					},
					{
						name: "Institute for Materials Science",
						link: "https://www.lanl.gov/projects//national-security-education-center/institute-for-materials-science/index.php"
					},
					{
						name: "Seaborg Institute",
						link: "https://www.lanl.gov/projects//national-security-education-center/seaborg/index.php"
					},
					{
						name: "Fellows",
						link: "https://www.lanl.gov/collaboration/fellows/index.php"
					}
				]
			},
			{
				name: "Research Opportunities",
				link: "https://www.lanl.gov/collaboration/research-opportunities/index.php",
				lc_pages: [
					{
						name: "Service Academies and ROTC Research Associates",
						link: "https://www.lanl.gov/collaboration/internships/service-academy-research-associates/index.php"
					},
					{
						name: "Strategic Analyses and Assessments Office",
						link: "https://www.lanl.gov/projects/strategic-analyses-and-assessments/index.php"
					}
				]
			}
		]
	},
	{
		name: "COMMUNITY",
		link: "https://www.lanl.gov/community/index.php",
		lc_page_groups: [
			{
				name: "Community Commitment",
				link: "https://www.lanl.gov/community/index.php",
				lc_pages: [
					{
						name: "Giving campaigns, drives",
						link: "https://www.lanl.gov/community/giving/index.php"
					},
					{
						name: "Economic development",
						link: "https://www.lanl.gov/community/economic-development.php"
					},
					{
						name: "Grants and Sponsorships",
						link: "https://www.lanl.gov/community/grantapplication.php"
					}
				]
			},
			{
				name: "Stem Education",
				link: "https://www.lanl.gov/community/education/index.php",
				lc_pages: [
					{
						name: "Teachers (K-12)",
						link: "https://www.lanl.gov/community/education/stem-education-programs.php"
					},
					{
						name: "Students (K-12)",
						link: "https://www.lanl.gov/community/education/teacher-resources/index.php"
					},
					{
						name: "Higher education",
						link: "https://www.lanl.gov/community/education/higher-education-resources/index.php"
					},
					{
						name: "Regional education partners",
						link: "https://www.lanl.gov/community/education/regional-partners/index.php"
					},
					{
						name: "NM Governor's STEM Challenge",
						link: "https://www.lanl.gov/community/education/stem-challenge/index.php"
					}
				]
			},
			{
				name: "Internal",
				link: "https://www.lanl.gov/community/visitors/index.php",
				lc_pages: [
					{
						name: "Badging, Badge Office",
						link: "https://www.lanl.gov/community/visitors/badging/index.php"
					},
					{
						name: "Bradbury Science Museum",
						link: "https://www.lanl.gov/community/visitors/bradbury-science-museum.php"
					},
					{
						name: "Housing",
						link: "https://www.lanl.gov/community/visitors/housing.php"
					},
					{
						name: "Maps",
						link: "https://www.lanl.gov/resources/maps.php"
					}
				]
			},
			{
				name: "Related Resources",
				link: null,
				lc_pages: [
					{
						name: "Calendar",
						link: "http://www.lanl.gov/calendar/"
					},
					{
						name: "Community Connections",
						link: "https://discover.lanl.gov/publications/connections"
					},
					{
						name: "Community feature stories",
						link: "https://www.lanl.gov/community/stories/index.php"
					}
				]
			}
		]
	},
	{
		name: "ENVIRONMENT",
		link: "https://www.lanl.gov/environment/index.php",
		lc_page_groups: [
			{
				name: "Environmental Protection",
				link: "https://www.lanl.gov/environment/protection/index.php",
				lc_pages: [
					{
						name: "What we monitor and why",
						link: "https://www.lanl.gov/environment/protection/monitoring/index.php"
					},
					{
						name: "Cultural preservation",
						link: "https://www.lanl.gov/environment/protection/cultural-preservation/index.php"
					},
					{
						name: "Taking care of our trails",
						link: "https://www.lanl.gov/environment/protection/trails/index.php"
					},
					{
						name: "Obeying environmental laws",
						link: "https://www.lanl.gov/environment/protection/compliance/index.php"
					},
					{
						name: "Protecting Wildlife",
						link: "https://www.lanl.gov/environment/protection/wildlife-protection/index.php"
					}
				]
			},
			{
				name: "Environmental Sustainability",
				link: "https://sustainability.lanl.gov/",
				lc_pages: [
					{
						name: "Sustainability goals",
						link: "https://sustainability.lanl.gov/goals-and-progress"
					},
					{
						name: "Recycling",
						link: "https://www.lanl.gov/environment/sustainability/recycling.php"
					},
					{
						name: "Green purchasing",
						link: "https://www.lanl.gov/environment/sustainability/green-purchasing.php"
					},
					{
						name: "Pollution prevention",
						link: "https://www.lanl.gov/environment/sustainability/pollution-prevention.php"
					},
					{
						name: "Reusing water",
						link: "https://www.lanl.gov/environment/sustainability/water-reuse.php"
					}
				]
			},
			{
				name: "Resources",
				link: null,
				lc_pages: [
					{
						name: "Environmental Management System",
						link: "https://www.lanl.gov/environment/protection/environmental-management-system.php"
					},
					{
						name: "Feature stories",
						link: "https://www.lanl.gov/environment/stories/index.php"
					},
					{
						name: "Public Reading Room",
						link: "https://www.lanl.gov/environment/public-reading-room.php"
					}
				]
			}
		]
	}
];
var lc_utility_menu = [
	{
		name: "Quick Links",
		lc_utility_item: [
			{
				name: "About",
				link: "https://about.lanl.gov"
			},
			{
				name: "Badging",
				link: "https://about.lanl.gov/visiting-lanl"
			},
			{
				name: "Business",
				link: "https://www.lanl.gov/business/procurement-opportunities.php"
			},
			{
				name: "Contacts",
				link: "https://www.lanl.gov/resources/contacts.php"
			},
			{
				name: "Maps",
				link: "https://www.lanl.gov/resources/maps.php"
			},
			{
				name: "Museum",
				link: "https://www.lanl.gov/museum//index.php"
			},
			{
				name: "Organizations",
				link: "https://organizations.lanl.gov/"
			},
			{
				name: "New Hires",
				link: "https://www.lanl.gov/careers/employees-retirees/new-hires/index.php"
			},
			{
				name: "Publications",
				link: "https://www.lanl.gov/discover/publications/index.php"
			},
			{
				name: "Research Library",
				link: "https://researchlibrary.lanl.gov"
			}
		]
	}
];
var menu_articles_environment = [
];
var menu_articles_community = [
	{
		card_image: {
			id: "5c7ccab6-d81f-4426-91e1-def73ff4c362",
			filename_disk: "5c7ccab6-d81f-4426-91e1-def73ff4c362.jpg",
			title: "2023-07-27",
			width: 1280,
			height: 853
		},
		feature_image: {
			id: "5617588f-c04a-4125-9046-377991981700",
			filename_disk: "5617588f-c04a-4125-9046-377991981700.jpg",
			title: "2023-08-10",
			width: 800,
			height: 571
		},
		news_type: null,
		slug: "0426-road-trip",
		title: "Your Manhattan Project road trip",
		status: "published"
	},
	{
		card_image: null,
		feature_image: {
			id: "1a81f2c9-fccf-417f-81b8-f62a0769222e",
			filename_disk: "1a81f2c9-fccf-417f-81b8-f62a0769222e.jpg",
			title: "2024-04-23",
			width: 800,
			height: 520
		},
		news_type: null,
		slug: "0423-food-drive",
		title: "Los Alamos National Laboratory Food Drive provides 289,000 meals",
		status: "published"
	},
	{
		card_image: null,
		feature_image: {
			id: "17220fcd-6203-4e39-8da7-380204dfa597",
			filename_disk: "17220fcd-6203-4e39-8da7-380204dfa597.jpg",
			title: "2024-04-11",
			width: 800,
			height: 533
		},
		news_type: null,
		slug: "0411-mapr-tours",
		title: "May 1: Register to tour 'behind the fence' at Manhattan Project National Historical Park",
		status: "published"
	}
];
var menu_articles_science = [
	{
		card_image: null,
		feature_image: {
			id: "783948ce-5abe-422b-bb49-7f2425f8d065",
			filename_disk: "783948ce-5abe-422b-bb49-7f2425f8d065.jpg",
			title: "2024-05-14",
			width: 800,
			height: 497
		},
		news_type: null,
		slug: "0514-clean-energy",
		title: "A new Los Alamos tech could give us clean energy and drinkable water",
		status: "published"
	},
	{
		card_image: null,
		feature_image: {
			id: "d390fa60-5335-4733-b8fc-3d2ccdf21eae",
			filename_disk: "d390fa60-5335-4733-b8fc-3d2ccdf21eae.jpg",
			title: "2024-03-27",
			width: 800,
			height: 522
		},
		news_type: null,
		slug: "0327-scorpius",
		title: "New machine to enhance understanding of nuclear weapons’ behavior ",
		status: "published"
	},
	{
		card_image: null,
		feature_image: {
			id: "b032a91f-5249-4b54-be34-a87c60bfe04f",
			filename_disk: "b032a91f-5249-4b54-be34-a87c60bfe04f.jpg",
			title: "2024-03-25",
			width: 771,
			height: 527
		},
		news_type: null,
		slug: "0325-safe",
		title: "‘SAFE’ technology protects data from theft and accidental distribution ",
		status: "published"
	},
	{
		card_image: {
			id: "b18660e8-1acb-43fc-a11e-f01df7c379ba",
			filename_disk: "b18660e8-1acb-43fc-a11e-f01df7c379ba.jpg",
			title: "2024-03-20 Card",
			width: 800,
			height: 686
		},
		feature_image: {
			id: "8e31b2d3-7a80-4d67-aee8-c1911afe8cd8",
			filename_disk: "8e31b2d3-7a80-4d67-aee8-c1911afe8cd8.jpg",
			title: "2024-03-20",
			width: 800,
			height: 422
		},
		news_type: null,
		slug: "0320-ai-chemistry-frontiers",
		title: "Artificial intelligence helps explore chemistry frontiers",
		status: "published"
	},
	{
		card_image: null,
		feature_image: {
			id: "76609d80-43d8-4828-b067-3fed23b6cc19",
			filename_disk: "76609d80-43d8-4828-b067-3fed23b6cc19.jpg",
			title: "2024-03-15",
			width: 800,
			height: 533
		},
		news_type: null,
		slug: "0315-ndalpha",
		title: "New technology can provide fast, in-field actinide measurements",
		status: "published"
	},
	{
		card_image: {
			id: "54f6c636-5dbc-465b-8bff-8e97e62afae0",
			filename_disk: "54f6c636-5dbc-465b-8bff-8e97e62afae0.jpg",
			title: "2024-03-12 card",
			width: 1400,
			height: 1120
		},
		feature_image: {
			id: "92972815-2272-4f05-a0c9-5fa3108f476f",
			filename_disk: "92972815-2272-4f05-a0c9-5fa3108f476f.jpg",
			title: "2024-03-12",
			width: 1576,
			height: 900
		},
		news_type: null,
		slug: "0312-ai-for-astrophysics",
		title: "AI for astrophysics: Algorithms help chart the origins of heavy elements",
		status: "published"
	}
];
var navData = {
	lc_menu: lc_menu,
	lc_utility_menu: lc_utility_menu,
	menu_articles_environment: menu_articles_environment,
	menu_articles_community: menu_articles_community,
	menu_articles_science: menu_articles_science
};

exports.default = navData;
exports.lc_menu = lc_menu;
exports.lc_utility_menu = lc_utility_menu;
exports.menu_articles_community = menu_articles_community;
exports.menu_articles_environment = menu_articles_environment;
exports.menu_articles_science = menu_articles_science;
//# sourceMappingURL=nav-data.json.js.map
